import axios from 'axios';

async function signIn(payload) {
  const { data } = await axios.post('/api/auth/sign-in', payload);
  return data;
}

async function signOut() {
  await axios.get('/api/auth/sign-out');
}

async function testToken() {
  await axios.get('/api/auth/test-token');
}

async function refreshTokens() {
  await axios.get('/api/auth/refresh-token');
}

async function forgotPassword(email) {
  const { data } = await axios.post('/api/auth/forgot-password', { email });
  return data;
}

async function resetPassword(email, code, newPassword) {
  const { data } = await axios.post('/api/auth/reset-password', {
    email,
    code,
    newPassword,
  });
  return data;
}

async function setNewPassword(email, session, newPassword) {
  const { data } = await axios.post('/api/auth/set-new-password', {
    email,
    session,
    newPassword,
  });
  return data;
}

export {
  forgotPassword,
  refreshTokens,
  resetPassword,
  setNewPassword,
  signIn,
  signOut,
  testToken,
};
